<template> 
    <div > 
        <div class="crumbs" hidden="true" style="margin-left:10px;" >
            <el-breadcrumb separator="/">
                <el-breadcrumb-item><i class="el-icon-lx-calendar"></i> 商品管理
                </el-breadcrumb-item>
                 <el-breadcrumb-item>限单配置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container" v-loading="loading2" element-loading-text="正在保存商品数据" element-loading-spinner="el-icon-loading">   
            <el-form ref="form3" :model="form4" style="margin-top:-20px" label-width="0"> 
                   
                    <span class="label-span" style="display:block;margin-top:10px ">
                        <label class="label">产品限量</label> 
                        <el-radio-group :disabled="config.edit" v-model.trim="form4.limitType" @change="saveGoodsConfig" > 
                            <el-radio-button label="0">不设限量</el-radio-button> 
                            <el-radio-button label="1">资源限量</el-radio-button> 
                            <el-radio-button label="2">产品限量</el-radio-button>  
                        </el-radio-group>  
                    </span>
                    <span class="label-span" style="display:block;margin-top:10px" v-if="form4.limitType==1 || form4.limitType==2">
                        <label class="label">总体限单</label> 
                        <el-input :disabled="config.edit" v-model.trim="form4.limitNum" oninput="value=value.replace(/[^\d]/g,'')" @change="saveGoodsConfig"  placeholder="总体限单数量" style="width:237px;"></el-input>
                    </span>    
                    <el-tooltip  content="点击解开编辑权限" placement="top">
                    <i style="color:#fff;font-size:25px;vertical-align:middle;cursor:pointer;color: #409eff;float:right;margin-right:15px;margin-top:-35px;" class='el-icon-edit-outline'  @click="setConfigEdit()"></i>
                    </el-tooltip>
                    <!-- <el-tooltip  content="点击撤回所有操作" placement="top">
                        <i class='el-icon-back' style="font-size:25px;cursor:pointer;" ></i>
                    </el-tooltip> -->
                 
            </el-form>
            <div  style="border: 1px dashed #409EFF;background:#ecf5ff;padding:15px 10px;margin-top:15px;">
                <div style="margin-bottom:10px;"> 
                    <span class="label-span2">
                        <label class="label2" >渠道名称</label> 
                        <el-input v-model.trim="query2.loginName" placeholder="下游渠道名称" style="width:120px;" class="handle-input mr10"></el-input> 
                    </span>
                    <span class="label-span2">
                        <label class="label2">渠道号码</label> 
                        <el-input v-model.trim="query2.memPhone" placeholder="下游渠道号码" style="width:120px;" class="handle-input mr10"></el-input> 
                    </span>    
                     <span class="label-span2">
                        <label class="label2">分配方式</label> 
                        <el-select v-model="query2.giveType"  placeholder="分类状态" clearable style="width:100px;" class="handle-select mr10">
                            <el-option value="" label="全部"  />  
                            <el-option value="1" label="定额分配"  /> 
                            <el-option value="2" label="大盘抢单"  /> 
                        </el-select> 
                    </span>    
                    <el-button type="success"  @click="handleSearch2">搜索</el-button>
                    <el-button type="error"   @click="refreshSearch2">重置</el-button> 
                </div>
                <el-table   :data="tableData2" border class="table"  ref="multipleTable" header-cell-class-name="table-header"  
                v-loading="loading4" style="max-height:450px;overflow-y:scroll"  element-loading-text="请稍等..." element-loading-spinner="el-icon-loading" > 
                    <el-table-column prop="loginName"  min-width="100" align="left" label="渠道名称"></el-table-column>
                    <el-table-column prop="memPhone"  min-width="110" align="center" label="渠道号码"></el-table-column> 
                    <el-table-column prop="isSm"  min-width="210" align="center" label="单量分配">
                        <template slot-scope="scope" > 
                            <el-radio v-model="scope.row.giveType" :disabled="config.edit" @change="giveTypeChange(scope.$index,scope.row)"  label="2">大盘抢单</el-radio> 
                            <el-radio v-model="scope.row.giveType" :disabled="config.edit" @change="giveTypeChange(scope.$index,scope.row)" label="1">定额分配</el-radio> 
                        </template>  
                    </el-table-column> 
                    <el-table-column prop="isSm" min-width="150" align="left" label="限制单量">
                        <template slot-scope="scope" >  
                            <p v-if='scope.row.giveType==2'><span class='redSpan'>  抢 {{scope.row.giveNum}} </span>  单/天</p>
                            <p v-else><input v-model.trim="scope.row.giveNum" :disabled="config.edit" @change="changeGiveNum()"  placeholder="限制单量" class='input' oninput="value=value.replace(/[^0-9.]/g,'')"  > 单/天</p>
                                
                        </template>  
                    </el-table-column>   
                </el-table>  
                <div class="pagination">
                    <el-pagination  background layout="total,  sizes,prev, pager, next,jumper"
                        :page-sizes="[10,20]"
                        :current-page="query2.pageIndex"
                        :page-size="query2.pageSize"
                        :total="pageTotal2"
                        @size-change="handleSizeChange2"
                        @current-change="handlePageChange2" 
                    ></el-pagination>
                </div> 
            </div>  
        </div>
     

         
    </div>
 
</template> 

<script>
import $ from 'jquery' ; 
import bus from '../common/bus';  
import { fetchData3,setLimitConfig,changeGive, changeStatus ,getGoodsConfig,saveGoodsConfig} from '../../api/comGoods';     
  
export default {

    data() {
        return {   
             
            goodsCode:'', 
            orderDis:true,
            config:{
                wid:'800px',
                top:'50px',
                edit:true,
            }, 
            configVisible:false,
            contentVisible:false,
            sureImgVisible:false, 
            sureImgVisible2:false, 
            saveContent:'0',
            contentVal:'',
            infoVisible:false,
            loading:false,
            loading2:false,
            loading3:false, 
            loading4:false, 
            query: { 
                pageIndex: 1,
                pageSize: 10,  
            }, 
            query2: { 
                pageIndex: 1,
                pageSize: 10,  
                goodsCode:'',
            },  
            tableData: [],
            tableData2: [], 
            skuCodes:[], 
            form4:{},
            idx: -1,
            id: -1
        };
    },
 
    beforeDestroy() {
        // 记得移除监听，避免内存泄漏
        bus.$off('limit-method');
    },
    created() { 
        
    },
    //页面加载方法
    mounted: function () { 
        //this.limitConfig();
        bus.$on('limit-method',  row  => { 
            this.limitConfigSet(row);
        });
    },
    

    methods: { 
        setEdit(){ 
            if(this.orderDis){
                this.orderDis = false;
            }else{
                this.orderDis = true;
            } 
        },
        setConfigEdit(){ 
            if(this.config.edit){
                this.$confirm('解开编辑权限后，修改的所有数据都将实时保存，确定要解开吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.config.edit = false;
                }) 
            }else{
                this.config.edit = true;
               
            }
        },
        numFilter(value) { 
            const realVal = parseFloat(value).toFixed(2); 
            return realVal; 
        },  
        fullOper(){ 
            if(this.widthSet=='450px'){ 
                this.widthSet="100%";
                this.topSet = "0";
                this.heightSet = "100%"; 
            }else{
                this.widthSet="450px";
                this.topSet = "50px";
                this.heightSet = "60%";
            } 
        }, 
        showLink1(row){
            var host = localStorage.getItem(window.location.hostname+'_stationUrl');
            var mid = localStorage.getItem(window.location.hostname+'_mid');
            //var link = "http://"+localStorage.getItem(window.location.hostname+'_indexUrl')+"/h5/templateCode_mid/goodsCode/memCode";
            this.linkUrl = "http://"+host+"/h5/goodsDoc/2/"+row.goodsCode;
            this.linkTitle = row.goodsName;
            this.wid = "400px";
            this.linkVisible = true;
        },
        showLink2(row){
            var host = localStorage.getItem(window.location.hostname+'_stationUrl');
            var mid = localStorage.getItem(window.location.hostname+'_mid');
            //var link = "http://"+localStorage.getItem(window.location.hostname+'_indexUrl')+"/h5/templateCode_mid/goodsCode/memCode";
            this.linkUrl = "http://"+host+"/h5/cl/code2_2/"+row.goodsCode;
            this.linkTitle = row.goodsName;
            this.wid = "360px";
            this.linkVisible = true;
        },
        showLink3(row){
            var host = localStorage.getItem(window.location.hostname+'_stationUrl');
            var mid = localStorage.getItem(window.location.hostname+'_mid');
            //var link = "http://"+localStorage.getItem(window.location.hostname+'_indexUrl')+"/h5/templateCode_mid/goodsCode/memCode";
            this.linkUrl = "http://"+host+"/h5/cl/cs_2/"+row.goodsCode;
            this.linkTitle = row.channelName+"-"+row.goodsName;
            this.wid = "1000px";
            this.linkVisible = true;
        },
        saveText(){
            if(this.saveContent == "0"){
               this.$set(this, 'saveContent','1'); 
               this.$notify({ title: '成功', message: '已成功保存落地页富文本内容',duration: 1000, type: 'success' });
            }else{
               this.$set(this, 'saveContent','0'); 
                this.$notify({ title: '成功', message: '已取消保存落地页富文本内容',duration: 1000, type: 'success' });
            }
           // 
            
        },
        limitConfig(){  
            this.config.edit = true;
            this.$set(this.config, 'edit',true);  
            this.$forceUpdate()
            this.query2.goodsCode =  localStorage.getItem(window.location.hostname+'_limit_goodsCode');  
            this.form4 = JSON.parse(localStorage.getItem(window.location.hostname+'_limit_goods')); 
            this.getData2(); 
            this.configVisible = true; 
        }, 
        limitConfigSet(row){      
            this.config.edit = true;
            this.$set(this.config, 'edit',true);   
            this.query2.goodsCode = row.goodsCode;   
            this.goodsConfig();
            this.getData2(); 
            this.configVisible = true; 
        }, 
        goodsConfig(){
            getGoodsConfig(this.query2).then(res => {   
                if(res.code=='200'){  
                    this.form4 = res.data; 
                    this.goodsConfigVisible = true;
                }else{
                    this.$message.error(res.message); 
                }
            });  
        },
        saveGoodsConfig(){  
            saveGoodsConfig(this.form4).then(res => {   
                if(res.code=='200'){    
                    this.goodsConfigVisible = false;
                    this.$notify({ title: '成功', message: '限单设置成功',duration: 1000, type: 'success' });
                }else{
                    this.$notify({ title: '失敗', message: '限单设置異常：'+res.message,duration: 1000, type: 'error' }); 
                }
            });  
        },
        LimitNumChange(){ 
            this.changeGiveNum(); 
        }, 
        giveTypeChange(index,row){  
            this.$set(this.tableData2[index], 'giveType',row.giveType);  
            //后台计算单量限制  
            this.changeGiveNum(); 
        }, 
        changeGiveNum(){   
            var num = 0;
            for(var i=0;i<this.tableData2.length;i++){
                if(this.tableData2[i].giveType==1){
                    num+=parseInt(this.tableData2[i].giveNum);
                }
            }  
            //系统后台计算  
            var limitConfig = [];
            var limitSet = [];
            for(var i=0;i<this.tableData2.length;i++){
                if(this.tableData2[i].giveType==1){ 
                    limitConfig.push(this.tableData2[i]);
                } 
                limitSet.push(this.tableData2[i]);
                 
            }  
            if(limitConfig && limitConfig.length>0){
                this.form4.limitConfig = JSON.stringify(limitConfig);
            } 
            if(limitSet && limitSet.length>0){
                this.form4.limitSet = JSON.stringify(limitSet);
            } 
            setLimitConfig(this.form4).then(res => {   
                if(res.code=='200'){  
                    this.$notify({ title: '成功', message: '限单设置成功',duration: 1000, type: 'success' });
                    for(var i=0;i<this.tableData2.length;i++){
                        if(this.tableData2[i].giveType==2){
                            this.getData2();
                            num+=parseInt(this.tableData2[i].giveNum=res.data);
                        }
                    } 
                }else{
                     this.$notify({ title: '失败', message: '限单设置失败：'+res.message,duration: 3000, type: 'error' });
                }
            });
            /* */
        },
        addContent(){
            this.contentVisible = true;
        },
        addSureImg(){
            this.sureImgVisible = true;
        },
        addSureImg2(){
            this.sureImgVisible2 = true;
        },
        //主图添加方法
        setImage(e){
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => { 
                this.cropImg = event.target.result;   
            };
            reader.readAsDataURL(file);     
        },
        //主图修改
        addImage(e){
            var that = this;
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const maxSize = 1024 * 1024; // 5MB
            if (file.size > maxSize) {
                this.$message.error(`图片大小不能超过1MB`);
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {    
                that.$set(that.form1, 'sureImg',event.target.result);     
                this.$nextTick(() => {
                    console.log('视图已更新');
                });
            };
            reader.readAsDataURL(file);   
        }, 
        addImage1(e){
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const maxSize = 100 * 1024; // 5MB
            if (file.size > maxSize) {
                this.$message.error(`图片大小不能超过100kb`);
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {  
                this.$set(this.form1, 'img1',event.target.result);  
                this.$nextTick(() => {
                    console.log('视图已更新');
                });
            };
            reader.readAsDataURL(file);  
        },
        addImage2(e){
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const maxSize = 100 * 1024; // 5MB
            if (file.size > maxSize) {
                this.$message.error(`图片大小不能超过100kb`);
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {  
                this.$set(this.form1, 'img2',event.target.result);  
                this.$nextTick(() => {
                    console.log('视图已更新');
                });
            };
            reader.readAsDataURL(file);  
        },
        addImage3(e){
            const file = e.target.files[0];   
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const maxSize = 100 * 1024; // 5MB
            if (file.size > maxSize) {
                this.$message.error(`图片大小不能超过100kb`);
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {  
                this.$set(this.form1, 'img3',event.target.result);  
                this.$nextTick(() => {
                    console.log('视图已更新');
                });
            };
            reader.readAsDataURL(file);  
        },
        changeImage(e){
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const maxSize = 1024 * 1024; // 5MB
            if (file.size > maxSize) {
                this.$message.error(`图片大小不能超过1MB`);
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {  
                this.form2.sureImg = event.target.result;
                this.$set(this.form2, 'sureImg',event.target.result);   
                this.$forceUpdate()
            };
            reader.readAsDataURL(file);  
        },
        changeImage1(e){
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const maxSize = 100 * 1024; // 5MB
            if (file.size > maxSize) {
                this.$message.error(`图片大小不能超过100kb`);
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {  
                this.$set(this.form2, 'img1',event.target.result);  
                this.$forceUpdate()
            };
            reader.readAsDataURL(file);  
        },
        changeImage2(e){
            const file = e.target.files[0];  
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const maxSize = 100 * 1024; // 5MB
            if (file.size > maxSize) {
                this.$message.error(`图片大小不能超过100kb`);
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {  
                this.$set(this.form2, 'img2',event.target.result);  
                this.$forceUpdate()
            };
            reader.readAsDataURL(file);  
        },
        changeImage3(e){
            const file = e.target.files[0];   
            if (!file.type.includes('image/')) {
                 this.$message.error("只能上传图片");
                return;
            }
            const maxSize = 100 * 1024; // 5MB
            if (file.size > maxSize) {
                this.$message.error(`图片大小不能超过100kb`);
                return;
            }
            const reader = new FileReader();
            reader.onload = (event) => {  
                this.$set(this.form2, 'img3',event.target.result);  
                this.$forceUpdate()
            };
            reader.readAsDataURL(file);  
        },
        //详情图上传成功追加数据 
        handleChange(file,fileList) {  
            const isJPG =file.raw.type === "image/png" || file.raw.type === "image/jpg" || file.raw.type === "image/jpeg";
            const isLt5M = file.size / 1024    < 1024;
            if (!isJPG) {
                this.$message.error("上传图片只能是 jpg、jpeg、png 格式!");
                fileList.splice(-1, 1);//移除错误文件
                return false;
            }
            if (!isLt5M) {
                this.$message.error("上传图片单张大小不能超过 1MB!");
                fileList.splice(-1, 1);
                return false;
            }  
            this.fileList = fileList;	  
            
        }, 
        //删除图片 
        handleRemove(file, fileList) {  
            let a = file.url ;
            let b = this.form1.detailPlain.indexOf(a);
            this.form1.detailPlain.splice(b,1);
            this.dialogImageUrl.splice(b,1); 
        }, 
        handleRemove(file) {   
            let i = this.fileList.indexOf(file);   
            this.fileList.splice(i,1); 
        }, 
        changeWidth(i){
            if(i==1){
                this.imgWidth = this.imgWidth - 50;
            }else{
                this.imgWidth = this.imgWidth + 50;
            } 
        },
        changeHeight(i){
            if(i==1){
                this.imgHeight = this.imgHeight - 50;
            }else{
                this.imgHeight = this.imgHeight + 50;
            } 
        },
        showMore(){
            if(this.showDiv){
                this.show = '>';
                this.showDiv = false;
            }else{
                this.show = 'v';
                this.showDiv = true;
            } 
        },
        //详情图放大
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url;
            this.dialogVisible = true; 
        }, 
        handleBig(url) {
            this.dialogImageUrl = url;
            this.dialogVisible = true; 
        },
        //文件上传超过最大数量提示
        overMaxImg(file,fileList){
            this.$message.error("详情图最多只能上传9张"); 
        },

        changeSelect(){
            this.getSelect6(this.query.ctype);
        },

        //获取下拉框数据
        getSelect(){ 
            this.select = {};  
            fetchSelect(this.select).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select, 'option', res.data);  
                }
            });
        },
        getSelect1(){ 
            this.select1 = {};  
            fetchSelect1(this.select1).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select1, 'option', res.data);  
                }
            });
        },
        getSelect2(){ 
            this.select2 = {}; 
            fetchSelect2(this.select2).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select2, 'option', res.data);  
                }
            });
        },
        getSelect3(){ 
            this.select3 = {}; 
            fetchSelect3(this.select3).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select3, 'option', res.data);  
                }
            });
        },
        getSelect4(){ 
            this.select4 = {}; 
            fetchSelect4(this.select4).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select4, 'option', res.data);  
                }
            });
        },
        getSelect5(){ 
            this.select5 = {};  
            fetchSelect5(this.select5).then(res => {   
                if(res.code=='200'){  
                    this.$set(this.select5, 'option', res.data);  
                }
            });
        },
        getSelect6(ctype){ 
            this.select6 = {}; 
            this.select6.ctype = ctype;
            fetchSelect6(this.select6).then(res => {   
                if(res.code=='200'){ 
                    this.$set(this.select6, 'option', res.data);  
                }
            });
        },
        getSelect7(){ 
            this.select7 = {};  
            fetchSelect7(this.select7).then(res => {   
                if(res.code=='200'){  
                    this.$set(this.select7, 'option', res.data);  
                }
            });
        },
         downExcel(){
             this.$confirm('确定要下载吗？', '提示', {
                type: 'warning'
            }).then(() => {
                this.loading3 = true;
                var host = localStorage.getItem(window.location.hostname+'_stationUrl'); 
                //var link = "http://"+localStorage.getItem(window.location.hostname+'_indexUrl')+"/h5/templateCode_mid/goodsCode/memCode"; 
                this.query.link1 = "http://"+host+"/h5/cl/code2_2/";
                this.query.link2 = "http://"+host+"/h5/goodsDoc/2/";
                setTimeout( () => {
                    this.loading3 = false;  
                    this.getData();
                }, 7000) 
                downOrderExcel(this.query).then(res => {   
                    this.loading3 = false
                    if(res.code=='200'){ 
                        this.$notify({ title: '成功', message: '后台下载成功',duration: 1000, type: 'success' });
                    }else{
                        this.$notify({ title: '失败', message: '后台下载异常',duration: 1000, type: 'error' });
                    }
                });
            });
        },
         getLink2(name,goodsCode){  
            var host = localStorage.getItem(window.location.hostname+'_stationUrl');
            var mid = localStorage.getItem(window.location.hostname+'_mid');
            //var link = "http://"+localStorage.getItem(window.location.hostname+'_indexUrl')+"/h5/templateCode_mid/goodsCode/memCode";
            var link = name+"： http://"+host+"/h5/cl/code2_2/"+goodsCode;
            this.copyLink(link,name);
        },

        getLink1(name,goodsCode){  
            var host = localStorage.getItem(window.location.hostname+'_stationUrl');
            var mid = localStorage.getItem(window.location.hostname+'_mid');
            //var link = "http://"+localStorage.getItem(window.location.hostname+'_indexUrl')+"/h5/templateCode_mid/goodsCode/memCode";
            var link = name+"： http://"+host+"/h5/goodsDoc/2/"+goodsCode;
            this.copyLink(link,name);
        },
         
        // 触发搜索按钮 
        handleSearch() {
            if(this.query.goodsTag){
                this.query.goodsTags = this.query.goodsTag.join();
            }else{
                this.query.goodsTags = "";
            }
            if(this.query.promoteArea){
                this.query.promoteAreas = JSON.stringify(this.query.promoteArea);
            }else{
                this.query.promoteArea = "";
            } 
            if(this.query.goodsId){
                this.query.goodsIds = this.query.goodsId.join();
            }else{
                this.query.goodsIds = "";
            } 
            this.$set(this.query, 'pageIndex', 1);
            this.getData(); 
        },
        refreshSearch2() {
            this.$set(this.query2, 'loginName');
            this.$set(this.query2, 'memPhone'); 
            this.$set(this.query2, 'giveType' );  
            this.$set(this.query2, 'pageIndex', 1);
            this.getData2();
        },
        handleSearch2(){
            this.getData2();
        },
        getData2(){
            // 获取列表数据   
            this.loading4 = true;
            fetchData3(this.query2).then(res => {  
                this.loading4 = false;
                if(res.code=='200'){ 
                    this.tableData2 = res.data.list;
                    this.pageTotal2 = res.data.pageTotal || 0;   
                }else{
                    this.tableData2 = []; 
                    this.pageTotal2 = 0;
                } 
                
            });
        },
        //查询商品id
        search(channelCode){
            let param = {};
            param.channelCode = channelCode;
            param.mid = this.mid;
            param.stationId = this.stationId;
            getSkuCodes(param).then(res => {   
                if(res.code=='200'){  
                    this.skuCodes = res.data.list;
                    this.skuVisible = true;
                }else{
                    this.$message.error(res.message); 
                }
            });
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'ctype'); 
            this.$set(this.query, 'channelCode' ); 
            this.$set(this.query, 'channelGoodsName'); 
            this.$set(this.query, 'channelGoodsCode');  
            this.$set(this.query, 'goodsRate');  
            this.$set(this.query, 'isp' );   
            this.$set(this.query, 'goodsName');  
            this.$set(this.query, 'goodsCode');  
            this.$set(this.query, 'goodsType');  
            this.$set(this.query, 'goodsFrom');  
            this.$set(this.query, 'goodsComType');  
            this.$set(this.query, 'status');  
            this.$set(this.query, 'promoteStatus');  
            this.$set(this.query, 'promoteArea');  
            this.$set(this.query, 'goodsTag');   
            this.$set(this.query, 'promoteAreas');  
            this.$set(this.query, 'goodsTags');   
            this.$set(this.query, 'goodsId');   
            this.handleSearch();
        },  

         //刷新
        refresh(){
            history.go(0); 
        },
        getImgDetail(goodsCode){ 
            this.imgUrl = "https://"+localStorage.getItem('ms_indexUrl')+"/hk/imgDetail?st="+this.stationId+"&gc="+goodsCode;
            var height = document.body.scrollHeight; 
            this.imgHeight = height*0.8; 
            this.imgVisible=true;
        },

        //查询
        getData(){
            // 获取列表数据   
            this.loading3 = true;
            fetchData(this.query).then(res => {  
                this.loading3 = false;
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal || 0;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        }, 
        getInfoDetail(goodsCode){
            this.imgUrl = "https://"+localStorage.getItem('ms_indexUrl')+"/hk/infoDetail?st="+this.stationId+"&gc="+goodsCode;
            this.infoVisible=true;
        },
         
        //复制
        handleCopy(index, row){
            row.mid = this.mid;
            row.stationId = this.stationId; 
            handleCopy(row).then(res => {
                if(res.code=='200'){
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    //处理该等级绑定的成员
                    this.$message.error(res.message); 
                } 
            }); 
        },
        //详情
        handDetail(index, row){
            $("#input_box3").html(row.goodsMore);
            //查询商品详情
            let detailParam = {};
            detailParam.stationId = this.stationId;
            detailParam.mid = this.mid;
            detailParam.goodsCode = row.goodsCode;
            backDetailImg(detailParam).then(res => {
                if(res.code=='200'){
                    this.detailImg = res.data; 
                }else{ 
                    this.$message.error(res.message); 
                }  
            });
            this.form3 = row;   
            this.detailVisible = true;   
        },
        // 多选操作
        handleSelectionChange(val) {
            this.multipleSelection = val; 
        },
        // 删除
        handDelete(index, row) { 
            row.stationId = this.stationId;  
            row.mid = this.mid;
           
            // 二次确认删除
            this.$confirm('确定要删除 《 '+row.goodsName+' 》 吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(row).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功'); 
                        this.getData();
                    }else{
                        this.$message.error(res.message); 
                    } 
                });
            }) 
        },
        //批量删除
        changeGrade() {
            const length = this.multipleSelection.length; 
            if(length===0){
                this.$message.error("请勾选要删除的商品");
                return;
            }
            var that = this;
            let param = {};
            let goodsCodes = ''; 
            let goodsNames = ''; 
            let title = ''; 
            let ids = '';
            that.delList = that.delList.concat(that.multipleSelection);
            for (let i = 0; i < length; i++) {
                goodsCodes += that.multipleSelection[i].goodsCode + ','; 
                ids += that.multipleSelection[i].id + ','; 
                goodsNames += that.multipleSelection[i].goodsName + ','; 
                title += that.multipleSelection[i].goodsName + '》,《'; 
            }  
                param.goodsCodes = goodsCodes.substr(0,goodsCodes.length-1);  
                param.ids = ids.substr(0,ids.length-1);  
                param.goodsNames = goodsNames.substr(0,goodsNames.length-1);  
                param.mid = that.mid;
                param.stationId = that.stationId;
                title = title.substr(0,title.length-3); 
            // 二次确认删除
            this.$confirm('确定要删除 《'+title+'》 吗？', '提示', {
                type: 'warning'
            }).then(() => { 
                handDeleteBatch(param).then(res => {
                    if(res.code=='200'){ 
                        that.$message.success(res.message); 
                        that.getData();
                    }else{ 
                        that.$message.error(res.message); 
                    } 
                });
            }) 
           

        }, 
         //上下架
        handleStatus(index,row){  
            if(row.status==0){
                this.loadingTitle = "下架";
            }else if(row.status==1){
                this.loadingTitle = "上架";
            } 
            this.loading = true; 
            changeStatus(row).then(res => {
                this.loading = false;
                if(res.code=='200'){  
                    this.$message.success(this.loadingTitle+"成功"); 
                    this.getData();
                }else{ 
                    this.$message.error(this.loadingTitle+"失败"); 
                }  
            }); 
        },

        handleProStatus(index,row){  
            let that = this;
            if(row.promoteStatus==0){ 
                row.promoteStatus='1';
                that.$prompt('请输入暂停推广'+row.goodsName+'原因（不超过50个字）', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',  
                    }).then(({ value }) => { 
                        row.promoteInfo = value;
                        row.promoteStatus='0';
                        that.loading = true;
                        changeStatus(row).then(res => {
                        that.loading = false;
                        if(res.code=='200'){  
                            that.$message.success(row.goodsName+"暂停推广成功"); 
                            that.getData();
                        }else{ 
                            that.$message.error(row.goodsName+"暂停推广失败:"+res.message); 
                        }  
                    });   
                }).catch(() => {
                       row.status='1'; 
                });
            }else{ 
                row.promoteInfo = '-'; 
                that.loading = true;
                changeStatus(row).then(res => {
                    that.loading = false;
                    if(res.code=='200'){  
                        that.$message.success(row.goodsName+"开启推广成功"); 
                        that.getData();
                    }else{ 
                        that.$message.error(row.goodsName+"开启推广失败:"+res.message); 
                    }  
                });
            } 
        },
 

        // 新增商品
        addBind() {   
            this.getSelect1();  
            this.getSelect2();  
            this.getSelect3(); 
            this.getSelect4(); 
            this.getSelect5();
            this.getSelect7(); 
            this.getSelect6(''); 
            this.fileList = [];
            this.getSelect6(this.query.ctype); 
            this.saveContent = "0";
            this.addVisible = true; 
        },
        validateNumberInput(input) {
            // 使用正则表达式替换非数字和小数点的字符
            input.value = input.value.replace(/[^0-9.]/g, '');

            // 确保只有一个小数点
            let parts = input.value.split('.');
            if (parts.length > 2) {
                input.value = parts[0] + '.' + parts.slice(1).join('');
            }

            // 确保不以小数点开头
            if (input.value.startsWith('.')) {
                input.value = input.value.substring(1);
            }
        },
       
        //保存新增
        saveForm() {    
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            if( !this.form1.channelCode ){
                this.isSubmitting = false;
                this.$message.error("请选择商品资源");
                return;
            }
            if( !this.form1.channelGoodsCode ){
                this.isSubmitting = false;
                this.$message.error("请填写商品编码");
                return;
            }
            if( !this.form1.channelGoodsName ){
                this.isSubmitting = false;
                this.$message.error("请填写商品名称");
                return;
            }  
            if( !this.form1.goodsRate ){
                this.isSubmitting = false;
                this.$message.error("请填写商品资费");
                return;
            } 
            if( !this.form1.channelCom ){
                this.isSubmitting = false;
                this.$message.error("请填写商品佣金");
                return;
            } 
            if( !this.form1.channelComType ){
                this.isSubmitting = false;
                this.$message.error("请选择结佣类型");
                return;
            }   
            if(this.form1.channelComType==2 && !this.form1.channelComTimes ){
                this.isSubmitting = false;
                this.$message.error("请填写返佣月份");
                return;
            } 
            if(!this.form1.goodsType){
                this.isSubmitting = false;
                this.$message.error("请填写产品分类");
                return;
            } 
            if(!this.form1.goodsFrom){
                this.isSubmitting = false;
                this.$message.error("请填写产品来源");
                return;
            } 
            if(!this.form1.goodsName){
                this.isSubmitting = false;
                this.$message.error("请填写产品名称");
                return;
            } 
            if(!this.form1.isp){
                this.isSubmitting = false;
                this.$message.error("请填写计费ISP");
                return;
            } 
            if(!this.form1.goodsComType){
                this.isSubmitting = false;
                this.$message.error("请填写结算类型");
                return;
            } 
            if(!this.form1.goodsCom){
                this.isSubmitting = false;
                this.$message.error("请填写产品佣金");
                return;
            } 
            if(!this.form1.goodsComType){
                this.isSubmitting = false;
                this.$message.error("请填写结算类型");
                return;
            } 
            if(this.form1.goodsComType==2 && !this.form1.goodsComTimes ){
                this.isSubmitting = false;
                this.$message.error("请填写结佣月份");
                return;
            } 
            if(this.goodsRead){ 
                this.form1.goodsRead = this.goodsRead.join();
            } 
            if(!this.goodsTag){
                this.isSubmitting = false;
                this.$message.error("请选择产品标签");
                return;
            }else{
                this.form1.goodsTag = this.goodsTag.join();
            } 
            if(this.fileList.length<1){
                this.isSubmitting = false;
                this.$message.error("请上传产品图片");
                return;
            }   
            if(!this.promoteArea || this.promoteArea==''){
                this.isSubmitting = false;
                this.$message.error("请选择推广范围");
                return;
            }else{
                
                this.form1.promoteArea = JSON.stringify(this.promoteArea);
            } 
            if(this.saveContent == "1"){
                this.form1.goodsContent = this.contentVal;
            }
            this.loading = true;  
            this.loadingTitle = "正在保存..."; 
            setTimeout( () => {
                this.loading = false;  
                this.getData();
            }, 7000)  
            saveForm(this.form1).then(res => { 
                if(res.code=='200'){   
                    this.addVisible = false;  
                    this.isSubmitting = false; 
                    //上传产品图片
                    let formData = new FormData();  
                    formData.append("goodsCode",res.data.goodsCode); 
                    formData.append("fileIds","");  
                    for(let j = 0; j < this.fileList.length; j++) {
                        formData.append("files", this.fileList[j].raw,this.fileList[j].name); 
                    }   
                    uploadDetailPlain(formData).then(res => {
                        this.loading = false;   
                        this.refreshSearch();
                        if(res.code=='200'){ 
                            this.$message.success("添加产品成功");  
                        }else{
                            this.addVisible = true;  
                            this.$message.error("产品图片上传失败！请重新编辑上传！"); 
                        }
                    }); 
                }else{
                    this.loading = false;  
                    this.isSubmitting = false; 
                    this.$message.error(res.message); 
                } 
            });
        },
        // 编辑操作
        handleEdit(index, row) {
            this.getSelect1();  
            this.getSelect2();  
            this.getSelect3(); 
            this.getSelect4(); 
            this.getSelect5();
            this.getSelect7(); 
            this.getSelect6(''); 
            let data = {};
            data.goodsCode = row.goodsCode;
            this.saveContent = "0";  
            getGoodsDetail(data).then(res => {
                if(res.code=='200'){ 
                    this.form2 = row; 
                    this.goodsTag2 = res.data.detail.goodsTag.split(",");  
                    if(res.data.detail.goodsRead!=null && res.data.detail.goodsRead!=""){
                        this.goodsRead2 = res.data.detail.goodsRead.split(","); 
                    } 
                    this.form2.smsSize = res.data.detail.smsSize;  
                    this.form2.sureContent = res.data.detail.sureContent;  
                    this.form2.sureImg = res.data.detail.sureImg;  
                    this.form2.img1 = res.data.detail.img1;  
                    this.form2.img2 = res.data.detail.img2;  
                    this.form2.img3 = res.data.detail.img3;  
                    this.form2.promoteRequire = res.data.detail.promoteRequire;  
                    if(res.data.detail.promoteArea){
                        this.promoteArea2 = JSON.parse(res.data.detail.promoteArea); 
                    } 
                    this.fileList = res.data.files;  
                    if(res.data.detail.goodsContent){ 
                        this.saveContent = '1';
                        this.contentVal = res.data.detail.goodsContent;  
                    } 
                    this.editVisible = true;
                }else{ 
                    this.$message.error(res.message); 
                } 
            });     
            
        },
        AesIdEdit(index, row){  
            let data = {};
            data.id = row.id;
            data.stationId = this.stationId;
            data.mid = this.mid;  
            data.aesId = row.aesId;
            data.goodsCode = row.goodsCode;
            updateAesId(data).then(res => {
                if(res.code=='200'){ 
                    this.getData();
                    this.$message.success(res.message);  
                }else{ 
                    this.$message.error(res.message); 
                } 
            });   
        },
        // 保存编辑
        saveEdit() {  
            if( !this.form2.channelCode ){
                this.$message.error("请选择商品资源");
                return;
            }
            if( !this.form2.channelGoodsCode ){
                this.$message.error("请填写商品编码");
                return;
            }
            if( !this.form2.channelGoodsName ){
                this.$message.error("请填写商品名称");
                return;
            }  
            if( !this.form2.goodsRate ){
                this.$message.error("请填写商品资费");
                return;
            } 
            if( !this.form2.channelCom ){
                this.$message.error("请填写商品佣金");
                return;
            }  
            if( !this.form2.channelComType ){
                this.$message.error("请选择结佣类型");
                return;
            }   
            if(this.form2.channelComType==2 && !this.form2.channelComTimes ){
                this.$message.error("请填写返佣月份");
                return;
            } 
            if(!this.form2.goodsType){
                this.$message.error("请填写产品分类");
                return;
            } 
            if(!this.form2.goodsFrom){
                this.$message.error("请填写产品来源");
                return;
            } 
            if(!this.form2.goodsName){
                this.$message.error("请填写产品名称");
                return;
            } 
            if(!this.form2.isp){
                this.$message.error("请填写计费ISP");
                return;
            } 
            if(!this.form2.goodsComType){
                this.$message.error("请填写结算类型");
                return;
            } 
            if(!this.form2.goodsCom){
                this.$message.error("请填写产品佣金");
                return;
            } 
            if(!this.form2.goodsComType){
                this.$message.error("请填写结算类型");
                return;
            } 
            if(this.form2.goodsComType==2 && !this.form2.goodsComTimes ){
                this.$message.error("请填写结佣月份");
                return;
            } 
            if(this.goodsRead){ 
                this.form2.goodsRead = this.goodsRead2.join();
            } 
            if(!this.goodsTag){
                this.$message.error("请选择产品标签");
                return;
            }else{
                this.form2.goodsTag = this.goodsTag2.join();
            } 
            if(this.fileList.length<1){
                this.$message.error("请上传产品图片");
                return;
            }  
            if(!this.promoteArea){
                this.$message.error("请选择推广范围");
                return;
            }else{
                this.form2.promoteArea = JSON.stringify(this.promoteArea2); 
            } 
            if(this.saveContent == "1"){
                this.form2.goodsContent = this.contentVal;
            }
            this.loading2 = true; 
            setTimeout( () => {
                this.loading2 = false;  
                this.getData();
            }, 5000)
            changeForm(this.form2).then(res => { 
                if(res.code=='200'){  
                    this.$message.success(res.message); 
                     //上传详情图
                    let formData = new FormData(); 
                    formData.append("goodsCode",this.form2.goodsCode); 
                    var fileIds="";
                    var fag = 0;
                    for(let j = 0; j < this.fileList.length; j++) {
                        if(this.fileList[j].raw){
                            fag = 1;
                            formData.append("files", this.fileList[j].raw,this.fileList[j].name); 
                        }else{
                            fileIds+= "'"+this.fileList[j].fileId+"',"; 
                        } 
                    }  
                    if(fileIds.length>1){fileIds=fileIds.substr(0,fileIds.length-1)}
                    formData.append("fileIds",fileIds);  
                    uploadDetailPlain(formData).then(res => { 
                        this.loading2 = false;
                        this.getData();
                        this.editVisible = false; 
                        if(res.code!='200'){
                            this.$message.error(res.message); 
                        }
                    });   
                     
                }else{
                    this.loading2 = false;
                    this.getData();
                    this.$message.error(res.message); 
                }
            });

           
        },
        copyLink(text,name){  
            var copy = document.createElement("input");
            copy.setAttribute("value", text);
            document.body.appendChild(copy);
            copy.select();
            document.execCommand("copy");
            document.body.removeChild(copy);  
            //提示已复制
            this.$message.success(name+"复制成功");  
        },

        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        },
        // 分页导航
        handlePageChange2(val) { 
            this.$set(this.query2, 'pageIndex', val);
            this.getData2();
        },
        //分页数量更改导航
        handleSizeChange2(val){
            this.$set(this.query2, 'pageSize', val);
            this.getData2();
        }
    }
};
</script>
<style> 
.chm-imgUl{
   width:560px;height:250px;margin-top:15px;
}
.chm-imgLi{
    list-style: none;
    float:left;width:100px;
    padding:0 20px;
}
.chm-imgFag{
    font-size: 35px;
    color: #ccc;
    position: relative;
    top: -100px;
    left: 30px;
}
.chm-imgDiv{
     position: relative;width: 100px;height: 160px; margin-top:-200px;border: 1px solid #eee;border-radius: 5px;background-color:#eee;opacity:0;box-sizing: border-box;
}
.chm-imgInput{
     width: 100px; height: 160px; cursor: pointer; 
}
.chm-imgTip{
    width:100px;
    background:rgb(245, 105, 24);
    color:#fff;
    height:35px;
    font-size: 13px;
    line-height:35px;
    display:inline-block;
    text-align: center;;
    margin-top:10px;
}
.el-dialog__title{
    font-size: 15px;;
}
 
.el-upload-list--picture-card .el-upload-list__item{
    width:80px ;
    height:80px ;
}
.el-upload--picture-card{
    width:80px ;
    height:80px ;
    line-height:80px ;
}

.ql-container{
    min-height:150px; 
  }
.ql-editor{
	height: 150px;
}
.contentHei .ql-editor{
    height: 450px;
}
#input_box{
	height: 100px;
	padding: 0 10px;
	font-size: 12px;
	word-wrap:break-word;/*为了在ie和FF顺利换行，加上word-wrap*/
	overflow-x:hidden;
	overflow-y: auto; /*visible (默认), hidden, scroll, 和auto*/
	outline:none;
    border:1px solid #ddd;
    border-radius:5px;
    line-height: 15px;
}
#input_box2{
	height: 100px;
	padding: 0 10px;
	font-size: 12px;
	word-wrap:break-word;/*为了在ie和FF顺利换行，加上word-wrap*/
	overflow-x:hidden;
	overflow-y: auto; /*visible (默认), hidden, scroll, 和auto*/
	outline:none;
    border:1px solid #ddd;
    border-radius:5px;
    line-height: 15px;
}
#input_box3{
	height: 100px;
	padding: 0 10px;
	font-size: 12px;
	word-wrap:break-word;/*为了在ie和FF顺利换行，加上word-wrap*/
	overflow-x:hidden;
	overflow-y: auto; /*visible (默认), hidden, scroll, 和auto*/
	outline:none;
    border:1px solid #ddd;
    border-radius:5px;
    line-height: 15px;
}
.imgOper{
    margin-top: -45px; 
    font-size: 18px; 
    float: right;
    margin-right: 20px;
}
.imgOper span{
    margin-right:20px;
}
.imgOper i{
    margin-right:10px;
}
    .el-dialog__body{
        padding:10px 20px;
    }
    .el-dialog__footer{
        padding: 0px 20px 20px;
    }
    .overflowy{

    overflow-x: hidden; /* 设置溢出滚动 */
   white-space: nowrap;
   overflow-y: scroll;
   /* 隐藏滚动条 */
   scrollbar-width: none; /* firefox */
   -ms-overflow-style: none; /* IE 10+ */
}
.overflowy::-webkit-scrollbar {
    display: none; /* Chrome Safari */
 
}
</style>
<style scoped> 
.layerDiv{
    position:fixed;
    height:200px;
    background: #333;
    opacity:0.7;
    z-index:100;
}
.input{
    width:80px;height:27px;line-height:27px;text-align:center;color:#ff2222;border:1px solid #aaa;border-radius:5px;font-weight:700 
}
.input:focus {
    outline:none;
    border: 1px solid #fb8a11;
}
.redSpan{
    width:80px;height:30px;line-height:30px;display:inline-block;text-align:center;color:#ff2222;font-weight:700 
}
.titleInfo{
    width:100%;
    text-align: center;
    line-height: 30px;
    height: 30px;
    font-size: 14px;
    color:#fff; 
    background:#0094d8;
    margin:-10px 0 10px 0; 
}
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    margin-bottom:5px;
    width: 120px;
    display: inline-block;
}

.handle-input {
    margin-bottom:5px;
    width: 180px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

/**/
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
@media screen and (max-width:999px){ 
  
 .goodDetails{
        font-size:12px;line-height:15px;height:18px;overflow-y:auto;
    }
    .goodRight{
        display:block;
    }
} 
@media screen and (min-width:999px){ 
    .goodDetails{
        font-size:15px;line-height:20px;height:22px;overflow-y:auto;
    }
    .goodRight{
        position:absolute;
        left:130px;
    }
}

</style>
